// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__15Hlk","title":"Images90_title__2FH5p","images":"Images90_images__1ZiyH"};